import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";

//components
import Spo2Button from "../../components/MainButtons/Spo2Button";
import HrButton from "../../components/MainButtons/HrButton";
import PVC from "../../components/MainButtons/PVC";
import StButton from "../../components/MainButtons/StButton";
import Pulse from "../../components/MainButtons/Pulse";
import RR from "../../components/MainButtons/RR";
import { Qtc } from "../../components/MainButtons/Qtc.js";

export const NumericBox1 = (props) => {
  const { state, setState } = useContext(AppContext);

  const handleBoxButtonClick = (boxNumber) => {
    setState((prevState) => {
      const updatedBoxes = prevState.numericValues.map((box) => {
        if (boxNumber === box.boxName) {
          return { ...box, isSelected: true };
        } else {
          return { ...box, isSelected: false };
        }
      });
      return { ...prevState, numericValues: updatedBoxes };
    });
  };

  return (
    <>
      {props.number === 1 && (
        <div
          style={{ gridArea: "box1", padding: "0" }}
          onClick={() => handleBoxButtonClick(1)}
        >
          {state.numericValues[0].box.spo && (
            <Spo2Button landscape={props.landscape} setting={props.setting} />
          )}
          {state.numericValues[0].box.hr && <HrButton />}
          {state.numericValues[0].box.pvc && <PVC />}
          {state.numericValues[0].box.pulse && (
            <Pulse landscape={props.landscape} />
          )}
          {state.numericValues[0].box.rr && <RR landscape={props.landscape} />}
          {state.numericValues[0].box.st && <StButton />}
          {state.numericValues[0].box.qtc && <Qtc />}
        </div>
      )}

      {props.number === 2 && (
        <div
          style={{ gridArea: "box2" }}
          onClick={() => handleBoxButtonClick(2)}
        >
          {state.numericValues[1].box.hr && <HrButton />}
          {state.numericValues[1].box.spo && (
            <Spo2Button landscape={props.landscape} setting={props.setting} />
            )}
          {state.numericValues[1].box.pvc && <PVC />}
          {state.numericValues[1].box.pulse && (
            <Pulse landscape={props.landscape} />
          )}
          {state.numericValues[1].box.rr && <RR landscape={props.landscape} />}
          {state.numericValues[1].box.st && <StButton />}
          {state.numericValues[1].box.qtc && <Qtc />}
        </div>
      )}

      {props.number === 3 && (
        <div
          style={{ gridArea: "box3" }}
          onClick={() => handleBoxButtonClick(3)}
        >
          {state.numericValues[2].box.hr && <HrButton />}
          {state.numericValues[2].box.spo && (
            <Spo2Button landscape={props.landscape} setting={props.setting} />
            )}
          {state.numericValues[2].box.pvc && <PVC />}
          {state.numericValues[2].box.pulse && (
            <Pulse landscape={props.landscape} />
          )}
          {state.numericValues[2].box.rr && <RR landscape={props.landscape} />}
          {state.numericValues[2].box.st && <StButton />}
          {state.numericValues[2].box.qtc && <Qtc />}
        </div>
      )}

      {props.number === 4 && (
        <div
          style={{ gridArea: "box4" }}
          onClick={() => handleBoxButtonClick(4)}
        >
          {state.numericValues[3].box.hr && <HrButton />}
          {state.numericValues[3].box.spo && <Spo2Button landscape={props.landscape} setting={props.setting}/>}
          {state.numericValues[3].box.pvc && <PVC />}
          {state.numericValues[3].box.pulse && <Pulse />}
          {state.numericValues[3].box.rr && <RR />}
          {state.numericValues[3].box.st && <StButton />}
          {state.numericValues[3].box.qtc && <Qtc />}
        </div>
      )}

      {props.number === 5 && (
        <div
          style={{ gridArea: "box5" }}
          onClick={() => handleBoxButtonClick(5)}
        >
          {state.numericValues[4].box.hr && <HrButton />}
          {state.numericValues[4].box.spo && <Spo2Button landscape={props.landscape} setting={props.setting} />}
          {state.numericValues[4].box.pvc && <PVC />}
          {state.numericValues[4].box.pulse && <Pulse />}
          {state.numericValues[4].box.rr && <RR />}
          {state.numericValues[4].box.st && <StButton />}
          {state.numericValues[4].box.qtc && <Qtc />}
        </div>
      )}

      {props.number === 6 && (
        <div
          style={{ gridArea: "box6" }}
          onClick={() => handleBoxButtonClick(6)}
        >
          {state.numericValues[5].box.hr && <HrButton />}
          {state.numericValues[5].box.spo && <Spo2Button landscape={props.landscape} setting={props.setting} />}
          {state.numericValues[5].box.pvc && <PVC />}
          {state.numericValues[5].box.pulse && <Pulse />}
          {state.numericValues[5].box.rr && <RR />}
          {state.numericValues[5].box.st && <StButton />}
          {state.numericValues[5].box.qtc && <Qtc />}
        </div>
      )}
    </>
  );
};
